export enum PromptType {
  DOCUMENT_PARSER = 'DOCUMENT_PARSER',
  MULTIMEDIA_ANALYZER = 'MULTIMEDIA_ANALYZER',
  ORGANIZATION = 'ORGANIZATION',
  TABLE = 'TABLE',
  WEB_PAGE = 'WEB_PAGE',
  WEB_SERVICES = 'WEB_SERVICES',
  INTEGRATION = 'INTEGRATION',
  TEXT = 'TEXT',
}
